




























































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetTestList$, DeleteTest$ } from "@/request/jxgl";
import SimplePagination from "@/components/simple_pagination.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    SimplePagination,
  },
})
export default class SjkList extends Vue {
  private filters: any = {
    试卷名称: "",
    current_page: 1,
    total_page: 0,
    total_count: 0,
  };
  // 列表
  private tests: any[] = [];
  private setFilters() {
    localStorage.setItem("sjkListFilters", JSON.stringify(this.filters));
  }
  /**
   * @description 跳转创建试卷
   */
  private jumpDetail() {
    this.$router.push("/main/jxgl/sjk-detail");
  }
  /**
   * @description 获得试卷列表
   */
  private fetchTestList() {
    const params = _.cloneDeep(this.filters);
    GetTestList$(this, params).then((data: any) => {
      // console.log(data);
      data.tests.forEach((test: any) => {
        test.selected = false;
      });
      this.$set(this, "tests", data.tests);
      this.filters.total_page = data.total_page;
      this.filters.total_count = data.total_count;
      this.setFilters();
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.current_page = 1;
    this.fetchTestList();
  }
  /**
   * @description 前一页
   */
  private prev() {
    if (this.filters.current_page === 1) {
      return;
    } else {
      this.filters.current_page--;
    }
    this.fetchTestList();
  }
  /**
   * @description 后一页
   */
  private next() {
    if (this.filters.current_page >= this.filters.total_page) {
      return;
    } else {
      this.filters.current_page++;
    }
    this.fetchTestList();
  }
  /**
   * @description 编辑试卷
   */
  private composeThis(test) {
    this.$router.push({
      path: "/main/jxgl/sjk-detail",
      query: {
        id: test.test_id,
      },
    });
  }
  /**
   * @description 删除一个考试
   */
  private deleteThis(test) {
    this.$confirm("删除后将无法找回，您确定要删除么？", { title: "温馨提示" })
      .then(() => {
        const params: any = {
          data: {
            test_id: test.test_id,
          },
        };
        DeleteTest$(this, params).then(() => {
          this.$message.success("删除成功");
          this.fetchTestList();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // 预览
  private preview(test) {
    this.$router.push({
      path: "/main/jxgl/sjk-preview",
      query: {
        id: test.test_id,
      },
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const localFilters = localStorage.getItem("sjkListFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        试卷名称: "",
        current_page: 1,
        total_page: 0,
        total_count: 0,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    this.fetchTestList();
  }
}
